import UserUpsertPage from '../user-upsert/UserUpsertPage';

export default UserUpsertPage;